window.STOREFRONT_ACCESS_TOKEN = "b901470aa645538e34da4a5991203278";
window.SHOPIFY_DOMAIN = "shopgolfdaddy.myshopify.com";

window.getCookieByName = function(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));

    return match ? match[2] : null;
}

window.setCookie = function (name, value) {
    const daysToExpire = new Date(2147483647 * 1000).toUTCString();
    const isSecure = window.location.protocol === 'https:';
    document.cookie = name + '=' + value + '; path=/; expires=' + daysToExpire + (isSecure ? '; secure; samesite=strict' : '; samesite=lax');
}

window.toCapitalize = function (value) {
    return value.charAt(0).toUpperCase() + value.slice(1);
}

window.sleepPromise = async function (ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

window.formatDate = function(value) {
    if (value == null) return '';

    if (typeof value === 'string') {
        const match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);

        if (match) return `${match[3]}.${match[2]}.${match[1].slice(-2)}`;
    }

    const date = value instanceof Date ? value : new Date(value);

    if (isNaN(date)) return '';

    const pad2 = number => String(number).padStart(2, '0');

    return `${pad2(date.getMonth() + 1)}.${pad2(date.getDate())}.${date.getFullYear()}`;
}

window.isSafariMacOS = function() {
    return /Macintosh/.test(navigator.userAgent) && navigator.vendor === "Apple Computer, Inc."
}

window.customerAuth = {
    accessToken: window.getCookieByName("customerBackendToken"),
    refreshToken: window.getCookieByName("customerBackendRefreshToken"),
    getAccessToken() {
        const token = window.getCookieByName("customerBackendToken");
        this.accessToken = token;
        return token;
    },
    getRefreshToken() {
        const token = window.getCookieByName("customerBackendRefreshToken");
        this.refreshToken = token;
        return token;
    },
    setAccessToken(token) {
        this.accessToken = token || null;
        if (token) window.setCookie("customerBackendToken", token);
    },
    setRefreshToken(token) {
        this.refreshToken = token || null;
        if (token) window.setCookie("customerBackendRefreshToken", token);
    },
    async refreshAccessToken() {
        try {
            const refreshToken = this.getRefreshToken();
            if (!refreshToken) return null;

            const response = await fetch(`${window.GD_API_BASE}/user-auth/refresh-token`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({refreshToken})
            });

            if (!response.ok) {
                console.error("Failed to refresh token", response.status);
                return null;
            }

            let payload = null;
            try {
                payload = await response.json();
            } catch {}

            const {accessToken, refreshToken: newRefreshToken} = payload?.data || {};

            if (accessToken) this.setAccessToken(accessToken);
            if (newRefreshToken) this.setRefreshToken(newRefreshToken);

            return accessToken || null;
        } catch (error) {
            console.error("Error refreshing access token:", error);
            return null;
        }
    },
    clearTokens() {
        this.accessToken = null;
        this.refreshToken = null;

        ["customerBackendToken", "customerBackendRefreshToken"].forEach((name) => {
            document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
        });
    },
    // the backend token is dead but the shopify session may not be, and
    // /account/login sends a logged-in customer straight back to /account, which
    // would call the api again and loop. logging out with return_url lands them on
    // the login form instead
    redirectToLogin() {
        if (this.isRedirectingToLogin) return;

        this.isRedirectingToLogin = true;
        this.clearTokens();

        const logoutUrl = window.routes?.account_logout_url || "/account/logout";
        const loginUrl = window.routes?.account_login_url || "/account/login";

        window.location.href = `${logoutUrl}?return_url=${loginUrl}`;
    }
};

window.initOtpInputs = function initOtpInputs(form, inputSelector = ".js-otp-input") {
    if (!form) return;
    // the account email-change flow calls this on every submit; a second set
    // of listeners would fight the first over focus
    if (form.dataset.otpBound) return;
    form.dataset.otpBound = "1";

    const inputs = [...form.querySelectorAll(inputSelector)];

    // spread a code across the boxes from the first one, clearing any box
    // the code does not reach, and focus the last digit placed
    const fill = (digits) => {
        inputs.forEach((inp, i) => {
            inp.value = digits[i] || "";
        });

        const lastFilledIndex = Math.min(digits.length, inputs.length) - 1;
        if (lastFilledIndex >= 0) {
            inputs[lastFilledIndex].focus();
        }
    };

    inputs.forEach((input, index) => {
        input.addEventListener("input", (e) => {
            const target = e.target;
            const digits = target.value.replace(/\D/g, "");

            // the emailed code autofilled (autocomplete="one-time-code") or
            // dropped in by the keyboard: the first box is the only one wide
            // enough (maxlength 6) to take it whole
            if (digits.length >= inputs.length) {
                fill(digits.slice(0, inputs.length));
                return;
            }

            // a digit typed into the widened first box next to an existing
            // one: keep the new digit only and leave the other boxes alone
            if (digits.length > 1) {
                target.value = e.data && /^\d$/.test(e.data) ? e.data : digits.slice(-1);
            } else {
                target.value = digits;
            }

            if (target.value && index < inputs.length - 1) {
                inputs[index + 1].focus();
            }
        });

        input.addEventListener("paste", (e) => {
            e.preventDefault();

            const pasteData = (e.clipboardData || window.clipboardData).getData("text");
            fill(pasteData.replace(/\D/g, "").split(""));
        });

        input.addEventListener("keydown", (e) => {
            if (e.key === "Backspace" && !input.value && index > 0) {
                inputs[index - 1].focus();
            }
        });
    });
};
